import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/IdentityProviderSettings/EditorData";


const updateUserPermissionsEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_FETCHED:
      return { ...state, identityProviderSettingsData: action.data };
    case ActionType.IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_COPIED:
      return { ...state, identityProviderSettingsData: { ...action.data} };
    case ActionType.IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_UPDATED:
      return { ...state, identityProviderSettingsData: { ...state.identityProviderSettingsData, ...action.data } };
    case ActionType.IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.IDENTITY_PROVIDER_SETTINGS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    case ActionType.IDENTITY_PROVIDER_SETTINGS_EDITOR_PROVIDER_SET:
      return { ...state, identityProviderSettingsData: {...state.identityProviderSettingsData, provider: action.data}};
    default:
      return state;
  }
};

export default updateUserPermissionsEditorData;
